export default __webpack_public_path__ + "static/media/misc-closetA-1440w.32c95d42.webp";